__webpack_require__.p = "/url-shortener/";